module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/event-badge-1efbc0116c5440e45e7797a8f1a914d9.svg";